export default __webpack_public_path__ + "static/char-38-anr-54800e439805f8f18220b999f088fc2d.gif";